import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import { changeTypeToName } from "../../helper/changeBankIdtoName";
import BackspaceRoundedIcon from '@mui/icons-material/BackspaceRounded';

const NumberButton = (props) => (
  <button
    className={`py-2 rounded col-span-2 text-${props.size} bg-gray-200 text-gray-600 font-bold focus:bg-defaultButtonNumberPlay focus:text-gray-900`}
    value={props.number}
    onClick={props.onClick}
  >
    {props.number}
    {props.icon}
  </button>
);

const NumberButtonDelete = (props) => (
  <button
    className={`py-2 col-span-2 text-center rounded text-${props.size} border bg-gray-200 text-gray-600 font-bold`}
    value={props.number}
    onClick={props.onClick}
  >
    <span className="mt-1.5 justify-self-center">
      {props.number}
      {props.icon}
      <span className="font-bold text-l ml-1">ลบ</span>
    </span>
  </button>
);

const Button = (props) => (
  <div className="w-full">
    <button
      value={props.number}
      className="w-full border border-defaultBorder rounded text-defaultText2 text-base font-bold focus:bg-blue-300 active:bg-blue-300"
      onClick={(e) => props.onClick(e.currentTarget.value.split(""))}
    >
      {props.number}

      <p className="w-full text-xs border-b border-r border-l border-green-200 bg-green-200 rounded-b text-right px-1 md:py-1 font-bold">
        {props.rate}
      </p>
    </button>
  </div>
);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  function range(start, end) {
    return Array(end - start + 1)
      .fill()
      .map((_, idx) => start + idx);
  }
  const zero = (num) => {
    if (num < 10) return "00" + num;
    if (num < 100) return "0" + num;
    return num;
  };
  // console.log(props)
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div className="grid grid-cols-5 gap-1 pt-3 md:grid-cols-10   ">
          {value != undefined ? (
            range(value * 100, value * 100 + 99).map((data, i) => (
              <Button
                key={i}
                number={zero(data)}
                rate="1000"
                onClick={props.onClickOption2}
              />
            ))
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
}

const Numpad = (props) => {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const changeTypeToNames = (data) => {
    const result = data.map((res, i) => changeTypeToName(res));
    return result.join();
  };

  return (
    <div className="mx-1 mb-1 border-t mt-2 ">
      {/* <div id="option0" className={`${props.index === 0 ? "block" : "hidden"}`}> */}
        <div className="w-auto h-auto rounded border-defaultButtonType3 mt-1 text-defaultText2">
          <div className="w-auto h-auto flex justify-center pt-1">
            {props.specialOption === "19_door" ||
            props.specialOption === "front_number" ||
            props.specialOption === "back_number" ? (
              <input
                className="px-1 text-[#b3853e] text-4xl bg-white outline-none text-center border border-[#b3853e] w-14 h-14 rounded mx-0.5 "
                disabled
                value={props.Number[0]}
              />
            ) : (
              props.Number.map((data, i) => (
                <input
                  key={i}
                  className="px-1 text-[#b3853e] font-bold text-4xl bg-white outline-none text-center border border-[#b3853e] w-14 h-14 rounded mx-0.5 shadow-md shadow-[#b3853e]"
                  disabled
                  value={props.Number[i]}
                />
              ))
            )}
          </div>
        {/* </div> */}

        <div className="grid grid-cols-12 gap-0.5 mt-2 ">
          <NumberButton onClick={props.onClickOption1} number="1" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="2" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="3" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="4" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="5" size="2xl" />
          <NumberButtonDelete
            onClick={props.deleteNumber}
            number=""
            icon={<BackspaceRoundedIcon/>}
            size="sm"
          />
          <NumberButton onClick={props.onClickOption1} number="6" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="7" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="8" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="9" size="2xl" />
          <NumberButton onClick={props.onClickOption1} number="0" size="2xl" />
          <NumberButton size="2xl" />
        </div>
      </div>

      <div id="option1" className={`${props.index === 1 ? "block" : "hidden"}`}>
        {props.type == "3" ? (
          <div>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable auto tabs example"
            >
              <Tab label="000" />
              <Tab label="100" />
              <Tab label="200" />
              <Tab label="300" />
              <Tab label="400" />
              <Tab label="500" />
              <Tab label="600" />
              <Tab label="700" />
              <Tab label="800" />
              <Tab label="900" />
            </Tabs>
            {/* <SwipeableViews
              className="overflow-y-auto "
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel
                value={value}
                index={0}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={1}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={2}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={3}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={4}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={5}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={6}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={7}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={8}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
              <TabPanel
                value={value}
                index={9}
                dir={theme.direction}
                onClickOption2={props.onClickOption2}
              />
            </SwipeableViews> */}
          </div>
        ) : props.type == "2" ? (
          <div className="grid grid-cols-5 gap-1 pt-3 md:grid-cols-10   ">
            {Array(100)
              .fill()
              .map((_, idx) => idx)
              .map((data, i) => (
                <Button
                  key={i}
                  number={data < 10 ? "0" + data : data}
                  onClick={props.onClickOption2}
                  rate="100"
                />
              ))}
          </div>
        ) : (
          <div className="grid grid-cols-5 gap-1 pt-3 md:grid-cols-10   ">
            <Button number="0" onClick={props.onClickOption2} rate="3.2" />
            <Button number="1" onClick={props.onClickOption2} rate="3.2" />
            <Button number="2" onClick={props.onClickOption2} rate="3.2" />
            <Button number="3" onClick={props.onClickOption2} rate="3.2" />
            <Button number="4" onClick={props.onClickOption2} rate="3.2" />
            <Button number="5" onClick={props.onClickOption2} rate="3.2" />
            <Button number="6" onClick={props.onClickOption2} rate="3.2" />
            <Button number="7" onClick={props.onClickOption2} rate="3.2" />
            <Button number="8" onClick={props.onClickOption2} rate="3.2" />
            <Button number="9" onClick={props.onClickOption2} rate="3.2" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Numpad;
